import { API } from "@/services"

export const SERVER_FEATURES_ENDPOINTS = {
  chart(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/features/chart`,
      method: 'GET',
      params,
    })
  },
  create(data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/features`,
      method: 'POST',
      data,
    })
  },
  get(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/features`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/features/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/features/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/features/${id}`,
      method: 'PUT',
      data,
    })
  },
}